/**
 * Shared Recharts `<Line dot>` renderer for isolated timeseries points.
 *
 * A line cannot draw a single point, and `dot={false}` hides it, so a lone real
 * value flagged `isIsolated` by `padSeriesToPeriod` (empty neighbours on both
 * sides) would otherwise be invisible. This renders a visible marker only for
 * those points; runs of consecutive points keep the clean dot-less line.
 *
 * Recharts calls this per point with `{cx, cy, payload, key, ...}` and the
 * function form of `dot` must return an SVG element (not null), so non-isolated
 * points return an empty `<g>`.
 */

const DOT_COLOR = 'var(--chart-1)';

type IsolatedDotProps = {
  cx?: number;
  cy?: number;
  payload?: { isIsolated?: boolean };
  // Recharts injects a per-dot key; forward it to avoid list-key warnings.
  key?: string;
};

export const renderIsolatedDot = ({ cx, cy, payload, key }: IsolatedDotProps) => {
  if (!payload?.isIsolated || cx == null || cy == null) {
    return <g key={key} />;
  }
  return (
    <circle
      key={key}
      cx={cx}
      cy={cy}
      r={4}
      fill={DOT_COLOR}
      stroke="var(--color-background)"
      strokeWidth={2}
    />
  );
};
